<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon style="margin-left:30px; margin-top:25px" color="white" x-large>mdi-check-network</v-icon>
            </v-card>
            <div class="usuario">PERMISOS</div>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="600px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on">
                  <v-icon color="white">mdi-plus-thick</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="nav">
                  <span class="headline" style="color:white">
                    <v-icon color="white">mdi-check-network</v-icon>
                    {{ formTitle }}
                  </span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field v-model="editedItem.nombre" label="Nombre" required></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field v-model="editedItem.cedula" label="Cédula" required></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-combobox
                          v-model="editedItem.cargo"
                          :items="cargos"
                          item-text="nombreCargo"
                          item-value="nombreCargo"
                          label="Cargo"
                          placeholder="Buscar o ingresar cargo..."
                          clearable
                          :loading="loadingCargo"
                          @update:search-input="buscarCargos"
                        ></v-combobox>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <!-- Campo de texto simple cuando se crea un permiso nuevo -->
                        <v-text-field
                          v-if="editedIndex === -1"
                          v-model="editedItem.activo_fijo"
                          label="Activo Fijo"
                          placeholder="Ingresar activo fijo..."
                          required
                        ></v-text-field>
                        <!-- Combobox con búsqueda cuando se edita un permiso existente -->
                        <v-combobox
                          v-else
                          v-model="editedItem.activo_fijo"
                          :items="permisosActivosFijos"
                          item-text="activo_fijo"
                          item-value="activo_fijo"
                          label="Activo Fijo"
                          placeholder="Buscar o ingresar activo fijo..."
                          clearable
                          :loading="loadingActivoFijo"
                          @update:search-input="buscarActivosFijos"
                        ></v-combobox>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field v-model="editedItem.dispositivo" label="Dispositivo" required></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-select v-model="editedItem.permiso" :items="['SI','NO']" label="Permiso" required></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" @click="close">Cancelar</v-btn>
                  <v-btn color="#1D3C7F" @click="save" :disabled="!isFormValid">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            class="text-field"
            color="#111c3d"
          ></v-text-field>

          <v-data-table
            :headers="headers.concat([{ text:'ACCIONES', value:'acciones', align:'center', sortable:false }])"
            :items="permisos"
            :search="search"
            style="border:2px solid #111c3d"
            class="elevation-3"
          >
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>No se encontró su búsqueda</v-alert>
            </template>

            <template v-slot:[`item.permiso`]="{ item }">
              <v-chip outlined :color="item.permiso==='SI'?'green':'red'">{{ item.permiso }}</v-chip>
            </template>

            <template v-slot:[`item.acciones`]="{ item, index }">
              <v-btn icon small color="#1D3C7F" @click="editItem(item,index)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <v-snackbar
            v-model="snackbar"
            :bottom="true"
            :timeout="6000"
            color="#3945d0"
            style="color:white"
          >
            {{ text }}
            <v-btn color="#3945d0" depressed @click="snackbar=false">Cerrar</v-btn>
          </v-snackbar>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";

export default {
  data() {
    return {
      permisos: [],
      cargos: [],
      permisosActivosFijos: [],
      search: "",
      searchCargo: "",
      searchActivoFijo: "",
      loadingCargo: false,
      loadingActivoFijo: false,
      dialog: false,
      editedItem: {
        id: null, nombre:"", cedula:"", cargo:"", activo_fijo:"", dispositivo:"", permiso:""
      },
      editedIndex: -1,
      snackbar: false,
      text: "",
      headers:[
        { text:"ID", value:"id", align:"center"},
        { text:"NOMBRE", value:"nombre", align:"center"},
        { text:"CÉDULA", value:"cedula", align:"center"},
        { text:"CARGO", value:"cargo", align:"center"},
        { text:"ACTIVO FIJO", value:"activo_fijo", align:"center"},
        { text:"DISPOSITIVO", value:"dispositivo", align:"center"},
        { text:"PERMISO", value:"permiso", align:"center"}
      ]
    };
  },
  computed:{
    formTitle(){ return this.editedIndex===-1?"Nuevo Permiso":"Editar Permiso"; },
    isFormValid(){ const e=this.editedItem; return e.nombre && e.cedula && e.activo_fijo && e.dispositivo && e.permiso; }
  },
  mounted(){ 
    this.obtenerPermisos(); 
    this.obtenerCargos();
  },
  methods:{
    close(){ 
      this.dialog=false; 
      this.editedItem={ id:null, nombre:"", cedula:"", cargo:"", activo_fijo:"", dispositivo:"", permiso:"" }; 
      this.editedIndex=-1;
      this.permisosActivosFijos=[]; // Limpiar sugerencias al cerrar
    },
    editItem(item,index){ this.editedItem=Object.assign({},item); this.editedIndex=index; this.dialog=true; },
    async obtenerPermisos(){
      try{
        const res=await axios.get(`${env.endpoint}EntradasSalidas/permisos`,{ params:{ search:this.search, cargo:this.searchCargo, activo_fijo:this.searchActivoFijo }});
        this.permisos=res.data;
      }catch{ this.permisos=[]; }
    },
    async obtenerCargos(){
      try{
        const res=await axios.get(`${env.endpoint}EntradasSalidas/cargos`);
        this.cargos=res.data.data||res.data||[];
      }catch{ this.cargos=[]; }
    },
    async buscarCargos(query){
      if(!query || query.length<2){ 
        this.obtenerCargos();
        return; 
      }
      this.loadingCargo=true;
      try{
        const res=await axios.get(`${env.endpoint}EntradasSalidas/cargos`,{ params:{ search:query }});
        this.cargos=res.data.data||res.data||[];
      }finally{ this.loadingCargo=false; }
    },
    async buscarActivosFijos(query){
      // Si es un permiso nuevo, no buscar, permitir escribir libremente
      if(this.editedIndex === -1) {
        return;
      }
      
      if(!query || query.length<2){ 
        this.permisosActivosFijos=[]; 
        return; 
      }
      this.loadingActivoFijo=true;
      try{
        const res=await axios.get(`${env.endpoint}EntradasSalidas/permisos`,{ params:{ activo_fijo:query }});
        this.permisosActivosFijos=res.data||[];
      }finally{ this.loadingActivoFijo=false; }
    },
    save(){
      console.log("[v0] Datos antes de procesar:", this.editedItem);
      
      let cargoValue = this.editedItem.cargo;
      if (typeof cargoValue === 'object' && cargoValue !== null) {
        cargoValue = cargoValue.nombreCargo || '';
      }
      
      let activoFijoValue = this.editedItem.activo_fijo;
      if (typeof activoFijoValue === 'object' && activoFijoValue !== null) {
        activoFijoValue = activoFijoValue.activo_fijo || '';
      }
      
      console.log("[v0] Valores procesados - cargo:", cargoValue, "activo_fijo:", activoFijoValue);
      
      const payload = {
        nombre: this.editedItem.nombre || '',
        cedula: this.editedItem.cedula || '',
        cargo: cargoValue || '',
        activo_fijo: activoFijoValue || '',
        dispositivo: this.editedItem.dispositivo || '',
        permiso: this.editedItem.permiso || ''
      };
      
      // Si es edición, agregar el id al payload
      if(this.editedIndex !== -1) {
        payload.id = this.editedItem.id;
      }
      
      console.log("[v0] Payload a enviar:", payload);
      
      const params = new URLSearchParams();
      Object.keys(payload).forEach(key => params.append(key, payload[key]));
      
      if(this.editedIndex === -1){
        // CREAR
        axios.post(`${env.endpoint}EntradasSalidas/permisos`, params, { 
          headers:{ "Content-Type":"application/x-www-form-urlencoded" } 
        })
          .then((response)=>{ 
            console.log("[v0] Respuesta del servidor (crear):", response);
            this.snackbar=true; 
            this.text="Permiso registrado satisfactoriamente"; 
            this.obtenerPermisos();
            this.close();
          })
          .catch((error)=>{ 
            console.error("[v0] Error al crear:", error);
            console.error("[v0] Respuesta del error:", error.response);
            this.snackbar=true; 
            this.text=error.response?.data?.mensaje || "Error al registrar permiso"; 
          });
      } else {
        // EDITAR - Usar PUT con el id en la URL (método correcto para CodeIgniter REST)
        const paramsPut = new URLSearchParams();
        Object.keys(payload).forEach(key => {
          if (key !== 'id') {
            paramsPut.append(key, payload[key]);
          }
        });
        
        console.log("[v0] Editando permiso ID:", this.editedItem.id);
        console.log("[v0] Params a enviar:", paramsPut.toString());
        
        axios.put(`${env.endpoint}EntradasSalidas/permisos/${this.editedItem.id}`, paramsPut, { 
          headers:{ "Content-Type":"application/x-www-form-urlencoded" } 
        })
          .then((response)=>{ 
            console.log("[v0] Respuesta del servidor (editar PUT):", response);
            console.log("[v0] Datos completos:", JSON.stringify(response.data, null, 2));
            
            // Verificar si se creó un nuevo registro (si el id de respuesta es diferente)
            const nuevoId = response.data?.id || response.data?.data?.id;
            if (nuevoId && nuevoId !== this.editedItem.id && nuevoId > this.editedItem.id) {
              console.error("[v0] ERROR: El backend creó un nuevo registro (ID:", nuevoId, ") en lugar de actualizar el ID:", this.editedItem.id);
              this.snackbar=true; 
              this.text="ERROR: Se creó un nuevo registro en lugar de actualizar."; 
              this.obtenerPermisos();
              return;
            }
            
            this.snackbar=true; 
            this.text=response.data?.mensaje || "Permiso editado satisfactoriamente"; 
            this.obtenerPermisos();
            this.close();
          })
          .catch((error)=>{ 
            console.error("[v0] Error al editar (PUT):", error);
            console.error("[v0] Status:", error.response?.status);
            console.error("[v0] Data:", error.response?.data);
            this.snackbar=true; 
            this.text=error.response?.data?.mensaje || `Error al editar permiso. Status: ${error.response?.status || 'desconocido'}. Verifique la consola.`; 
          });
      }
    }
  }
};
</script>
